import { defineMessages, useIntl } from 'react-intl'
import LogoJamango from 'assets/images/logos/Jamango.svg'
import JamangoPicture1 from 'assets/images/zones/jamango/jamango_view_1.png'
import JamangoPicture2 from 'assets/images/zones/jamango/jamango_view_2.png'
import JamangoPicture3 from 'assets/images/zones/jamango/jamango_view_3.png'
import JamangoPicture4 from 'assets/images/zones/jamango/jamango_view_4.png'
import JamangoPicture5 from 'assets/images/zones/jamango/jamango_view_5.png'
import JamangoPicture6 from 'assets/images/zones/jamango/jamango_view_6.png'
import ZonesModalCategory, {
    BulletsMessages,
} from 'routes/Tickets/sections/ZonesDescription/components/ZonesModal/components/ZonesModalCategory'

const ZonesCategoryJamango = () => {
    const { formatMessage } = useIntl()

    const name = formatMessage({
        id: 'zones.modal.jamango_name',
        defaultMessage: 'Jamango',
    })
    const description = formatMessage({
        id: 'zones.modal.jamango_description',
        defaultMessage: 'Wodna rozrywka dla całej rodziny',
    })
    const bullets: BulletsMessages = defineMessages({
        pt0: {
            id: 'zones.modal.jamango_bullet_1',
            defaultMessage: '35 zjeżdżalni',
        },
        pt1: {
            id: 'zones.modal.jamango_bullet_2',
            defaultMessage: '7 basenów',
        },
        pt2: {
            id: 'zones.modal.jamango_bullet_3',
            defaultMessage: '5 restauracji',
        },
        pt3: {
            id: 'zones.modal.jamango_bullet_4',
            defaultMessage: 'Surfing na sztucznej fali <span>(40 zł/h)</span>',
        },
        pt4: {
            id: 'zones.modal.jamango_bullet_5',
            defaultMessage:
                'Crocodile Island <span>(1200m² dodatkowej przestrzeni dla dzieci)</span>',
        },
    })

    const images = [
        JamangoPicture1,
        JamangoPicture2,
        JamangoPicture3,
        JamangoPicture4,
        JamangoPicture5,
        JamangoPicture6,
    ]

    return (
        <ZonesModalCategory
            iconUrl={LogoJamango}
            zoneName={name}
            shortDescription={description}
            bullets={bullets}
            images={images}
        />
    )
}

export default ZonesCategoryJamango
